import { render, staticRenderFns } from "./ModalInsertFields.vue?vue&type=template&id=712ec1e3&scoped=true&lang=html&"
import script from "./ModalInsertFields.vue?vue&type=script&lang=js&"
export * from "./ModalInsertFields.vue?vue&type=script&lang=js&"
import style0 from "./ModalInsertFields.vue?vue&type=style&index=0&id=712ec1e3&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712ec1e3",
  null
  
)

export default component.exports